import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useLogin, useRegister } from "../query/auth";

// Экран входа/регистрации — порт #auth-screen + submitAuth/setAuthMode (web/index.html + app-pages.js).
// Валидация: имя ≥ 3, пароль ≥ 6, email обязателен при регистрации (как в legacy).
const schema = z.object({
  username: z.string().min(3, "Имя ≥ 3 символов"),
  password: z.string().min(6, "Пароль ≥ 6 символов"),
  email: z.union([z.string().email("Неверный email"), z.literal("")]),
});
type FormValues = z.infer<typeof schema>;

export function AuthScreen() {
  const [mode, setMode] = useState<"login" | "register">("login");
  const isReg = mode === "register";
  const login = useLogin();
  const register = useRegister();
  const mutation = isReg ? register : login;
  const {
    register: field,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: { username: "", password: "", email: "" },
  });

  const onSubmit = handleSubmit((v) => {
    if (isReg && !v.email) {
      setError("email", { message: "Email обязателен" });
      return;
    }
    mutation.mutate({ username: v.username, password: v.password, email: isReg ? v.email : "" });
  });

  const apiErr = mutation.isError ? (mutation.error as Error).message : "";
  const fieldErr = errors.username?.message || errors.password?.message || errors.email?.message || "";

  return (
    <div className="auth-screen">
      <div className={`auth-card${mutation.isError ? " shake" : ""}`}>
        <div className="auth-brand">
          <img className="brand-mark" src="/logo.svg" alt="" width={28} height={28} />
          <span className="brand-name">kquant</span>
        </div>
        <p className="auth-tagline">Конструктор и проверка торговых стратегий</p>
        <div className="auth-tabs">
          <button type="button" className={`auth-tab${!isReg ? " active" : ""}`} onClick={() => setMode("login")}>
            Вход
          </button>
          <button type="button" className={`auth-tab${isReg ? " active" : ""}`} onClick={() => setMode("register")}>
            Регистрация
          </button>
        </div>
        <form className="auth-form" onSubmit={onSubmit} autoComplete="off" noValidate>
          <label className="auth-field">
            <span>Имя пользователя</span>
            <input type="text" autoComplete="username" {...field("username")} />
          </label>
          {isReg ? (
            <label className="auth-field">
              <span>Email</span>
              <input type="email" autoComplete="email" {...field("email")} />
            </label>
          ) : null}
          <label className="auth-field">
            <span>Пароль</span>
            <input type="password" autoComplete={isReg ? "new-password" : "current-password"} {...field("password")} />
          </label>
          <div className="auth-err">{fieldErr || apiErr}</div>
          <button type="submit" className="btn primary lg auth-submit" disabled={mutation.isPending}>
            {mutation.isPending ? <span className="spin" /> : null}
            {isReg ? "Создать аккаунт" : "Войти"}
          </button>
        </form>
        <p className="auth-hint">{isReg ? "Имя ≥ 3 символов, email обязателен, пароль ≥ 6." : ""}</p>
      </div>
    </div>
  );
}
